import { useEffect, useState } from "react";

/**
 * Returns "now" as a Date that updates on the given interval. Used by route-
 * manager urgency helpers — when current time crosses a window threshold
 * (e.g., 31 min before window start → 30 min before), the chip colour and
 * map pin rim need to flip.
 *
 * Default 60 sec: chip colour transitions are minute-precision, so polling
 * faster wastes renders without visible benefit. Each consumer can pass a
 * different interval if it needs sub-minute precision.
 */
export function useNow(intervalMs = 60_000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
